import { render, staticRenderFns } from "./PxSituacaoCotacaoMarketplaceAdmin.vue?vue&type=template&id=61b8c14a"
import script from "./PxSituacaoCotacaoMarketplaceAdmin.vue?vue&type=script&lang=js"
export * from "./PxSituacaoCotacaoMarketplaceAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports